import { Billboard, Text } from "@react-three/drei";
import { PROJECTS } from "../data/content";
import { projectPedestalPosition } from "./poi";

export default function ProjectPedestals({ onSelect }) {
  return (
    <group>
      {PROJECTS.map((project, i) => {
        const pos = projectPedestalPosition(i, PROJECTS.length);
        return (
          <group key={project.id} position={pos}>
            <mesh position={[0, 0.05, 0]}>
              <cylinderGeometry args={[0.9, 1.1, 0.1, 16]} />
              <meshBasicMaterial color="#FF007F" transparent opacity={0.25} toneMapped={false} />
            </mesh>
            <mesh
              position={[0, 1.6, 0]}
              onClick={(e) => {
                e.stopPropagation();
                onSelect(project);
              }}
              onPointerOver={() => (document.body.style.cursor = "pointer")}
              onPointerOut={() => (document.body.style.cursor = "default")}
              data-testid={`game-project-pedestal-${project.id}`}
            >
              <octahedronGeometry args={[0.55, 0]} />
              <meshBasicMaterial color="#01FFFF" wireframe toneMapped={false} />
            </mesh>
            <Billboard position={[0, 2.7, 0]}>
              <Text fontSize={0.4} color="#E0E6ED" anchorX="center" anchorY="middle">
                {project.index} {project.title}
              </Text>
            </Billboard>
          </group>
        );
      })}
    </group>
  );
}
